import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import './PageTop10TV.css';

function formatNumber(n) {
  return n.toLocaleString('en-US', { maximumFractionDigits: 0 });
}

const TV_TOTAL = 353510190;

const TV_DATA = [
  { pos: 1,  canal: 'CANAL 5',          slug: 'canal-5',           inv: 109295015, spots: 138574, inv6y: [109295015,105608786,79226254,81390380,63796862,48409131] },
  { pos: 2,  canal: 'HCH',              slug: 'hch',               inv: 58408058,  spots: 171886, inv6y: [58408058,50462929,26800676,22943637,19050899,13682834] },
  { pos: 3,  canal: 'CANAL 11',         slug: 'canal-11',          inv: 47551917,  spots: 98124,  inv6y: [47551917,50897548,38404625,34033759,32231034,22825615] },
  { pos: 4,  canal: 'TELESISTEMA 3Y7',  slug: 'telesistema-3y7',   inv: 47400128,  spots: 118321, inv6y: [47400128,42790541,37156748,37989669,27255737,20028052] },
  { pos: 5,  canal: 'TELECADENA 7Y4',   slug: 'telecadena-7y4',    inv: 22183617,  spots: 58781,  inv6y: [22183617,22215559,22039998,23210809,19483844,17846790] },
  { pos: 6,  canal: 'CANAL 10',         slug: 'canal-10',          inv: 18017425,  spots: 91841,  inv6y: [18017425,21552901,19906520,13867957,21305963,20406248] },
  { pos: 7,  canal: 'VTV',              slug: 'vtv',               inv: 8882984,   spots: 33243,  inv6y: [8882984,8617617,12563080,14789070,32419244,24960094] },
  { pos: 8,  canal: 'AZTECA HONDURAS',  slug: 'azteca-honduras',   inv: 7553755,   spots: 71172,  inv6y: [7553755,4749974,3790154,6747451,13003118,16553246] },
  { pos: 9,  canal: 'QHUBOTV',          slug: 'qhubotv',           inv: 7407248,   spots: 109476, inv6y: [7407248,6267339,4407304,2745180,2558119,774777] },
  { pos: 10, canal: 'DEPORTES TVC',     slug: 'deportes-tvc',      inv: 5358688,   spots: 39415,  inv6y: [5358688,1729885,0,0,0,0] },
];

function Sparkline({ inv6y }) {
  const chronological = [...inv6y].reverse();
  const inv2025 = inv6y[0];
  const inv2020 = inv6y[5];
  const isUp = inv2025 >= inv2020;
  const color = isUp ? '#4ade80' : '#f87171';

  const w = 100;
  const h = 32;
  const padX = 3;
  const padY = 4;

  const max = Math.max(...chronological);
  const min = Math.min(...chronological);
  const range = max - min || 1;

  const points = chronological.map((val, i) => {
    const x = padX + (i / (chronological.length - 1)) * (w - padX * 2);
    const y = padY + (1 - (val - min) / range) * (h - padY * 2);
    return `${x},${y}`;
  });

  const polyline = points.join(' ');
  const firstX = padX;
  const lastX = padX + (w - padX * 2);
  const areaPoints = `${firstX},${h - padY} ${polyline} ${lastX},${h - padY}`;

  const pctChange = inv2020 > 0
    ? ((inv2025 - inv2020) / inv2020 * 100).toFixed(0)
    : null;

  return (
    <div className="spark-wrap">
      <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
        <defs>
          <linearGradient id={`sg-tv-${isUp ? 'u' : 'd'}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity="0.25" />
            <stop offset="100%" stopColor={color} stopOpacity="0.02" />
          </linearGradient>
        </defs>
        <polygon points={areaPoints} fill={`url(#sg-tv-${isUp ? 'u' : 'd'})`} />
        <polyline points={polyline} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        {(() => {
          const lp = points[points.length - 1].split(',');
          return <circle cx={lp[0]} cy={lp[1]} r="2" fill={color} />;
        })()}
      </svg>
      <span className={`spark-pct ${isUp ? 'spark-up' : 'spark-down'}`}>
        {pctChange !== null ? (isUp ? '+' : '') + pctChange + '%' : 'NEW'}
      </span>
    </div>
  );
}

function PageTop10TV() {
  const navigate = useNavigate();
  const maxInv = TV_DATA[0].inv;

  return (
    <PageBackground>
      <div className="top10tv-page">
        <header className="top10tv-header">
          <button className="btn-back" onClick={() => navigate('/medio-ooh')}>
            &#8592; OOH
          </button>
          <div className="top10tv-title-block">
            <h1 className="top10tv-title">Top 10 Canales de TV</h1>
            <p className="top10tv-subtitle">Televisi&oacute;n &middot; Honduras 2025 &middot; USD &middot; ${formatNumber(TV_TOTAL)}</p>
          </div>
          <button className="btn-race" onClick={() => navigate('/race-tv')}>
            &#9654; Race Video
          </button>
          <button className="btn-next" onClick={() => navigate('/top20-spots')}>
            Top 10 Radio &#8594;
          </button>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <div className="top10tv-table-wrap">
          <table className="tv-table">
            <thead>
              <tr>
                <th className="tvt-pos">#</th>
                <th className="tvt-name">Canal</th>
                <th className="tvt-inv">Valor Mercado</th>
                <th className="tvt-pct">%</th>
                <th className="tvt-spots">Spots</th>
                <th className="tvt-spark">Inv. 6Y</th>
              </tr>
            </thead>
            <tbody>
              {TV_DATA.map((row, idx) => {
                const pct = (row.inv / TV_TOTAL) * 100;
                return (
                  <tr key={row.pos} className="tvt-row" style={{ animationDelay: `${idx * 0.05}s` }}>
                    <td className="tvt-pos">
                      <span className={`tvt-pos-badge ${row.pos <= 3 ? 'tvt-pos-top3' : ''}`}>
                        {row.pos}
                      </span>
                    </td>
                    <td className="tvt-name">
                      <span className="tvt-canal-name tvt-canal-link" onClick={() => navigate(`/top25-canal/${row.slug}`)}>{row.canal}</span>
                      <div className="tvt-bar-bg">
                        <div className="tvt-bar" style={{ width: `${(row.inv / maxInv) * 100}%` }}></div>
                      </div>
                    </td>
                    <td className="tvt-inv">${formatNumber(row.inv)}</td>
                    <td className="tvt-pct">{pct.toFixed(2)}%</td>
                    <td className="tvt-spots">{formatNumber(row.spots)}</td>
                    <td className="tvt-spark"><Sparkline inv6y={row.inv6y} /></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageTop10TV;
